import {
  signIn as awsSignIn,
  signOut as awsSignOut,
  confirmSignUp as awsConfirmSignUp,
  updateUserAttributes as awsUpdateUserAttributes,
  getCurrentUser,
  fetchUserAttributes,
  resendSignUpCode,
  updatePassword,
  resetPassword,
  confirmResetPassword
} from "aws-amplify/auth";
import { ForgotPasswordType, LoginProviderFormType, ResendVerificationCodeType, VerifyProviderEmailType } from "./types";
import { axiosWithAPIKey } from "../../Services/Axios";
import { APIResponseType } from "../../Services/Models/Async/AsyncModel";

type PasswordState = {
  currentPassword: string;
  newPassword: string;
}

export async function signIn(values: LoginProviderFormType) {
  try {
    const user = await awsSignIn({ username: values.email, password: values.password }).then(async (res: any) => {
      let user = await fetchUserAttributes();
      let dashboard = {
        daily: {
          critical: 4,
          caution: 2,
          stable: 1,
        },
        weekly: {
          critical: 4,
          caution: 2,
          stable: 1,
        }
      }
      return { data: { ...{ id: user.username, username: user.username, ...user, dashboard } }, success: true };
    });
    return user;
  } catch (error: any) {
    return { success: false, code: error.code, message: error.message };
  }
}

// export async function signUp(values: Pick<SetUpProviderPasswordType, "email" | "password">) {
//   try {
//     const { user } = await awsSignUp({
//       username: values.email,
//       password: values.password as string,
//       options: {
//         userAttributes: {
//           email: values.email,
//           name: values.email.split("@")[0],
//           family_name: "N/A",
//           "custom:tempUnit": "F",
//           "custom:location": "N/A",
//           "custom:orgName": "N/A",
//           "custom:occupation": "N/A",
//           "custom:orgID": "N/A"
//         },
//       },
//       autoSignIn: true
//     });
//     return { data: { ...user }, success: true, email: values.email, username: values.email, };
//   } catch (error: any) {
//     return { success: false, message: error.message, code: error };
//   }
// }

export async function signOut() {
  try {
    await awsSignOut();
    return { success: true, message: "Logout successful" };
  } catch (error: any) {
    return { success: false, code: error.code, message: error.message };
  }
}

export async function confirmSignUp(values: VerifyProviderEmailType) {
  try {
    const resp: any = await awsConfirmSignUp({ username: values.username, confirmationCode: values.code }).then(async () => {
      return { success: true, verifyFor: values.verifyFor };
    }).catch((error: any) => {
      return { success: false, message: error.message, code: error.code }
    });
    return resp;
  } catch (error: any) {
    return { success: false, message: error.message, code: error.code, testKey: "TestKey" }
  }
}

export async function getCurrentAuthUser() {
  try {
    let user = await getCurrentUser();
    let attributes = await fetchUserAttributes();
    return { data: { ...{ id: user.username, username: user.username, ...attributes } }, success: true };
  } catch (error: any) {
    return { success: false, code: error.code, message: error.message };
  }
}

export async function resendConfirmationCode(values: ResendVerificationCodeType) {
  try {
    if (values.verifyFor === "register" || values.verifyFor === "login") {
      await resendSignUpCode({ username: values.username });
      return { success: true, message: "Verification code has been sent to: " + values.username };
    } else {
      // await Auth.forgotPassword(values.username); // initiate password reset
      return { success: true, message: "Verification code has been sent to: " + values.username };
    }
  } catch (err: any) {
    return { success: false, message: err.message, code: err.code };
  }
}

export async function updateUserAttributes(attributes: any) {
  try {
    let user = await getCurrentUser();
    const userUpdate = await awsUpdateUserAttributes({ userAttributes: attributes });
    if (userUpdate) {
      return { data: { id: user.username, username: user.username, ...attributes }, success: true, message: "User Data Updated Successfully." };
    } else {
      return { success: false, code: "PROMISE_FAILED", message: "Error in UpdateUserAttributes" };
    }
  } catch (error: any) {
    return { success: false, code: error.code, message: error.message };
  }
}

export async function updateUserPassword(values: PasswordState) {
  try {
    const response = await updatePassword({ oldPassword: values.currentPassword, newPassword: values.newPassword }).then((res: any) => {
      return { success: true, message: "Password Updated Successfully." }
    }).catch((error: any) => {
      return { success: false, code: error.code, message: error.message };
    }); // change the user's password
    return response;
  } catch (error: any) {
    return { success: false, code: error.code, message: error.message };
  }
}

// =========> To Update Password from Forgot Password Functionality

export async function initiateResetPassword(username: string) {
  try {
    const respo = await resetPassword({ username }); // initiate password reset
    console.log("respo", respo);
    return { success: true, message: "Verification code has been sent to: " + username };
  } catch (error: any) {
    return { success: false, code: error.code, message: error.message };
  }
}

export async function resetUserPassword(values: ForgotPasswordType) {
  try {
    await confirmResetPassword({ username: values.username, confirmationCode: values.verificationCode, newPassword: values.password }); // submit new password along with verification code and email
    return { success: true, message: "Password Reset Successful" };
  } catch (error: any) {
    return { success: false, code: error.code, message: error.message };
  }
}

export async function userAccountCheck(email: string) {
  try {
    const response = await axiosWithAPIKey.post('check-provider', { email }).then((response: APIResponseType<any>) => {
      const finalResponse = response.data;
      return { success: true, code: finalResponse.code, message: finalResponse.data.email_status };
    }).catch((error) => {
      return { success: false, code: error.code, message: error.message };
    })
    return response;
  } catch (error: any) {
    console.log("error:", error.toString());
    return { success: false, code: error.code, message: error.message };
  }
}
// To Update Password from Forgot Password Functionality <=========

export function updateProviderDashboardAPI(values: any) {
  try {
    if (values) {
      return { success: true, message: "" };
    }
  } catch (error: any) {
    return { success: false, message: error }
  }
}